<script lang="ts" setup>
import { cva, type VariantProps } from 'class-variance-authority'

import { classMerge } from '../utils'

const definitionListItemVariants = cva('pb-1 border-b border-separator', {
  variants: {
    variant: {
      list: 'flex justify-between items-baseline gap-1.5',
      grid: 'w-[calc(50%-14px)] flex justify-between items-baseline gap-1.5',
      columns: 'flex-1 flex flex-col gap-0.5'
    }
  },
  defaultVariants: {
    variant: 'list'
  }
})

type DefinitionListItemProps = VariantProps<typeof definitionListItemVariants>

withDefaults(
  defineProps<{
    variant?: DefinitionListItemProps['variant']
  }>(),
  {
    variant: 'list'
  }
)
</script>

<template>
  <div :class="classMerge(definitionListItemVariants({ variant }))">
    <slot />
  </div>
</template>
